import React, { Component } from 'react';
import { Row, Col, Modal, Spin, Radio, Checkbox, message } from 'antd';
import Text from '../../basicElement/Text';
import API_URL from '../../../common/url';
import addToDownloadSite from '../../shared/addToDownloadSite';

const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;
const radioStyle = {
    display: 'block',
};
const statisticOption = [
    { label: '待配置中心FTE占比', value: 'CONFIG_SITE' },
    { label: '按月合计', value: 'INV_MONTH_TOTAL' },
    { label: '当月末累计合计', value: 'MONTH_END_CUMULATIVE' },
    { label: '预估总工时', value: 'ESTIMATE_TOTAL_FTE' },
    { label: '截至本月末的完工%', value: 'MONTH_END_PERCENT' },
    { label: '本月完工%', value: 'CURRENT_MONTH_PERCENT' },
    { label: '合同&初始计划', value: 'CONTRACT_PLAN' },
    { label: '累计进度动态参考值', value: 'TOTAL_PROGRESS_CONSULT' },
    { label: '合同FTE数', value: 'CONTRACT_FTE' },
    { label: '合同FTE差值', value: 'CONTRACT_FTE_DIFFERENC' },
    { label: '备注', value: 'INV_REMARK' },
];

class ExportModal extends Component {
    state = {
        visible: false,
        loading: false,
        data: {},
    }

    show = () => {
        this.setState({
            data: {
                range: 'total',
                type: 'validate',
            },
            visible: true
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            type: 'SUMMARY',
        });
    }

    handleChange = (value, key) => {
        const { data } = this.state;
        switch (key) {
            case 'range':
                data[key] = value;
                data.type = value === 'detail' ? undefined : (data.type || 'validate');
                break;
            case 'type':
                data[key] = value;
                data.statistic = [];
                break;
            default:
                data[key] = value;
                break;
        }
        this.setState({ data });
    }

    confirm = () => {
        const { searchParams } = this.props;
        const { data } = this.state;
        const { range, type, statistic } = data;

        const params = {
            ...searchParams,
            type: range === 'total' ? 'SUMMARY' : 'DETAIL',
        };
        let downloadType = range === 'total' ? 'ALL_FINISH' : 'ALL_FINISH_DETAIL';

        if (type === 'finance') {
            if (!statistic || !statistic.length) {
                return message.warning('请选择导出统计项！');
            }
            params.type = 'PERCENT_FINANCE';
            params.options = statistic.join(',');
            downloadType = 'PERCENT_FINANCE';
        }

        addToDownloadSite(params, API_URL.sumtotal.exportAllInvestigation, downloadType);
        this.hide();
    }

    render() {
        const { visible, loading, data } = this.state;
        
        return (
            <Modal
                title="导出"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                width="500px"
                maskClosable={false}
                confirmLoading={loading}
                bodyStyle={{ maxHeight: 500 }}
            >
                <Spin spinning={loading}>
                    <div className="historyContractRecordUpdate percent-export">
                        <Row>
                            <Col span={6}>
                                <Text colon={true}>导出数据范围</Text>
                            </Col>
                            <Col span={17} offset={1}>
                                <RadioGroup onChange={e => this.handleChange(e.target.value, 'range')} value={data.range}>
                                    <Radio value="total" style={radioStyle}>完工百分比汇总数据</Radio>
                                    <Radio value="detail" style={radioStyle}>完工百分比明细数据</Radio>
                                </RadioGroup>
                            </Col>
                        </Row>
                        {
                            data.range === 'total' &&
                            <Row>
                                <Col span={6}>
                                    <Text colon={true}>导出方式</Text>
                                </Col>
                                <Col span={17} offset={1}>
                                    <RadioGroup onChange={e => this.handleChange(e.target.value, 'type')} value={data.type}>
                                        <Radio value="validate" style={radioStyle}>全部(核对版)</Radio>
                                        <Radio value="finance" style={radioStyle}>全部(财务版)</Radio>
                                    </RadioGroup>
                                </Col>
                            </Row>
                        }
                        {
                            data.type === 'finance' &&
                            <Row>
                                <Col span={6}>
                                    <Text colon={true}>导出统计项</Text>
                                </Col>
                                <Col span={17} offset={1}>
                                    <CheckboxGroup
                                        value={data.statistic}
                                        options={statisticOption}
                                        onChange={value => this.handleChange(value, 'statistic')}
                                    />
                                </Col>
                            </Row>
                        }
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default ExportModal;


// WEBPACK FOOTER //
// ./src/components/sumTotal/proPercent/ExportModal.js